import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import LoggingInBox from "../Partials/LoggingInBox";
import IncorrectCredentialsBox from "../Partials/IncorrectCredentialsBox";
import UserAlreadyLoggedInBox from "../Partials/UserAlreadyLoggedInBox";
import Footer from "../Partials/Footer";
import { TextField, Box, Button, Typography } from "@mui/material";
import { login } from "../../api/admin";
import "./Styling.css";
import { urlbase, tenauto } from "../../constants/Constants";
import Div from "../../components/common/Div";
import Image from "../../components/common/Image";
import UserDeactiated from "../Partials/UserDeactiated";
import {useAuth} from "../../context/AuthContext";
import { s3BaseUrl } from "../../config/envConfig";

export default function Login() {
  const history = useHistory();
  const [localUser, setLocalUser] = useState({ id_num: "", password: "" });
  const [loggedIn, setLoggedIn] = useState(localStorage.getItem("isLoggedIn"));
  const [isLoading, setIsLoading] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const [error, setError] = useState(false);
  const [userAlreadyLoggedIn, setUserAlreadyLoggedIn] = useState(false);
  const [marketingMaterials, setMarketingMaterials] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [usernameTouched, setUsernameTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loginAttempt, setLoginAttempt] = useState(false);
  const [userDeactivated, setUserDeactivated] = useState(false);
  const { user, setUser } = useAuth();
  const marketingFetched = useRef(false);

  const getInfoDoc = async () => {
    let purl = await fetch(urlbase().concat("info_url"));
    let url = await purl.text();
    window.open(url);
  };

  const LoginHandler = async (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);

    if (localUser.id_num === "" || localUser.password === "") {
      if (localUser.id_num === "") setUsernameError(true);
      if (localUser.password === "") setPasswordError(true);
      setIsButtonDisabled(false);
      return;
    }

    const loginResponse = await login(localUser.id_num, localUser.password);

    if (loginResponse.code === 200) {
      const localUser = loginResponse.data;
      localStorage.setItem("isLoggedIn", "1");
      if (
        localUser.student.grade === "FET" ||
        localUser.student.grade === "SP" ||
        localUser.student.grade === "Other" ||
        localUser.student.grade === "Teacher"
      ) {
        localStorage.setItem("Grade", "Teacher");
      } else {
        localStorage.setItem("Grade", localUser.student.grade);
      }
      if (
        localUser.student.grade === "FET" ||
        localUser.student.grade === "SP" ||
        localUser.student.grade === "Other" ||
        localUser.student.grade === "Teacher"
      ) {
        localStorage.setItem("RefGrade", "Teacher");
      } else {
        localStorage.setItem("RefGrade", localUser.student.grade);
      }
      localStorage.setItem("Subject", "");
      localStorage.setItem("RefSubject", "");
      localStorage.setItem("RefSearchTerm", "");
      localStorage.setItem("SearchTerm", "");
      localStorage.setItem("user", JSON.stringify(localUser));
      setUser(localUser);

      history.push("/testdashboard");

    } else {
      if (loginResponse.data.status === 404) {
        setIsLoading(false);
        setLoginFailed(true);
      } else if (loginResponse.data.status === 403) {
        setIsLoading(false);
        setUserAlreadyLoggedIn(true);
      } else if (loginResponse.data.status === 405) {
        setIsLoading(false);
        setUserDeactivated(true);
      }

      setError(true);
    }
    setTimeout(() => setIsButtonDisabled(false), 5000);
  };

  const getMarketingMaterials = async () => {
    try {
      const url = urlbase().concat("marketing");
      const response = await fetch(url);
      if (!response.ok) throw new Error("HTTP " + response.status);
      const temp = await response.json();
      setMarketingMaterials(temp);
    } catch (e) {
      console.error("Failed to load marketing materials", e);
    }
  };

  useEffect(() => {
    localStorage.clear();
    if (!marketingFetched.current) {
      marketingFetched.current = true;
      getMarketingMaterials();
    }
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getImages = () => {

    const isMobile = window.innerWidth <= 768;

    return (
      <Div>
        <div style={{ display: "flex", gap: "12px", flexDirection: isMobile ? "column" : "row", justifyContent: "center", padding: isMobile ? "32px 64px" : "21px 0", background: "#03122e" }}>
          <div style={{ flex: "0 1 33%", order: isMobile ? -1 : Math.floor(marketingMaterials.length / 2), borderRadius: "5px", overflow: "hidden", background: "#fff" }}>
            <Image
              src={
                s3BaseUrl + "/gmmdc_logo.png"
              }
              alt={"GMMDC Logo"}
            />
          </div>
          {marketingMaterials.length === 0 ? null : marketingMaterials.map((x, i) => {
            return (
              <div key={i} style={{ flex: "0 1 33%", order: i, borderRadius: "5px", overflow: "hidden", background: "#fff" }}>
                <Image src={x} alt={"Marketing Material " + i} />
              </div>
            );
          })}
        </div>
      </Div>
    );
  };

  const handleInputChange = (key, value) => {
    setLocalUser((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleInputBlur = (key, value) => {
    if (key === "id_num") {
      setUsernameTouched(true);
      if (value !== "") setUsernameError(false);
      else setUsernameError(true);
    }
    if (key === "password") {
      setPasswordTouched(true);
      if (value !== "") setPasswordError(false);
      else setPasswordError(true);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      LoginHandler(event);
    }
  };

  return (
    <>
      <LoggingInBox display={isLoading} />
      <IncorrectCredentialsBox
        display={loginFailed}
        setLoginFailed={setLoginFailed}
      />
      <UserAlreadyLoggedInBox
        display={userAlreadyLoggedIn}
        setLoginFailed={setUserAlreadyLoggedIn}
      />
      <UserDeactiated
        display={userDeactivated}
        setLoginFailed={setUserDeactivated}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: windowWidth >= 800 ? "50%" : "80%",
        }}
      >
        <div>
          <img
            src={
              s3BaseUrl + "/mobitutorza_logo_full.png"
            }
            alt={"Logo"}
            width={"250px"}
            height={"250px"}
          />
        </div>
        <div>
          <p style={{ color: "white", fontSize: "1.25em", fontWeight: "bold" }}>
            Login
          </p>
        </div>
        <div>
          <hr style={{ width: "100%", marginBottom: "20px" }}></hr>
        </div>
        <Box
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            <TextField
              sx={{
                backgroundColor: "rgba(224, 224, 224, 0.12)",
                borderRadius: "5px",
                "& .MuiInputBase-input": {
                  padding: "15px 14px",

                  color: "white",
                },
                "&.Mui-focused": {
                  borderColor: "#00112e",
                  "--joy-palette-primary-500": "#01ACC7",
                },
                width: "100%",
              }}
              InputProps={{
                sx: {
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FBCD02",
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "white",
                  "&.Mui-focused": {
                    color: "#FBCD02",
                  },
                },
              }}
              label="Username"
              variant="outlined"
              onChange={(e) => handleInputChange("id_num", e.target.value)}
              onBlur={(e) => handleInputBlur("id_num", e.target.value)}
              onKeyDown={handleKeyDown}
              error={usernameError}
            />
            {usernameError && (
              <Typography
                sx={{
                  color: "red",
                  fontSize: "0.8rem",
                  textAlign: "left",
                }}
              >
                Username cannot be empty.
              </Typography>
            )}
          </div>

          <div>
            <TextField
              sx={{
                backgroundColor: "rgba(224, 224, 224, 0.12)",
                borderRadius: "5px",
                "& .MuiInputBase-input": {
                  padding: "15px 14px",

                  color: "white",
                },
                "&.Mui-focused": {
                  borderColor: "#00112e",
                  "--joy-palette-primary-500": "#01ACC7",
                },
                width: "100%",
              }}
              InputProps={{
                sx: {
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FBCD02",
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "white",
                  "&.Mui-focused": {
                    color: "#FBCD02",
                  },
                },
              }}
              label="Password"
              variant="outlined"
              type="password"
              onChange={(e) => handleInputChange("password", e.target.value)}
              onBlur={(e) => handleInputBlur("password", e.target.value)}
              onKeyDown={handleKeyDown}
              error={passwordError}
            />
            {passwordError && (
              <Typography
                sx={{
                  color: "red",
                  fontSize: "0.8rem",
                  textAlign: "left",
                }}
              >
                Password cannot be empty.
              </Typography>
            )}
          </div>
          <Button
            variant="contained"
            disabled={isButtonDisabled}
            style={{
              backgroundColor: "#FBCD02",
              color: "#00112e",
              width: "100%",
              height: "3.2em",
              fontWeight: "bold",
            }}
            onClick={LoginHandler}
          >
            LOGIN
          </Button>
          <Box display="flex" justifyContent="space-between" alignItems="left">
            <p style={{ color: "white", fontSize: "0.90rem" }}>
              <span
                onClick={() => history.push("/forgotpassword")}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Forgot Password?
              </span>
            </p>
            <p style={{ color: "white", fontSize: "0.90rem" }}>
              <span
                onClick={() =>
                  history.push("/contactus", { forgotPassword: "true" })
                }
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Contact Us
              </span>
            </p>
            <p style={{ color: "white", fontSize: "0.90rem" }}>
              <span
                onClick={getInfoDoc}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                More Information
              </span>
            </p>
          </Box>
        </Box>
        {getImages()}
      </div>

      <Footer />
    </>
  );
}
